// NOTE: This file is maintained in the parent project AS Common.
//       Your application should avoid modifying this file.

import { CssBaseline as MuiCssBaseline } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { App } from "app/App";
import { AlertsProvider, Page, Theme, useAuth, UsersProvider } from "common";
import { BrowserRouter } from "react-router";

export const AppRoot = () => {
  const auth = useAuth();
  const isTestEnvironment =
    import.meta.env.DEV && import.meta.env.VITE_ENVIRONMENT === "test";

  return (
    <div>
      {(isTestEnvironment || auth.isAuthenticated) && (
        <MuiThemeProvider theme={Theme}>
          <MuiCssBaseline />
          <BrowserRouter>
            <AlertsProvider>
              <UsersProvider>
                <Page>
                  <App />
                </Page>
              </UsersProvider>
            </AlertsProvider>
          </BrowserRouter>
        </MuiThemeProvider>
      )}
    </div>
  );
};
